module.exports = "/_next/static/images/b64bbe42e22c92dc1d17d17c86c8f1e0-blog3-xs.png";